export default {
  // ALL PROJECT
  MERCHANT_INFO: {},
  PROJECT_INFO: {},
  PROJECT_LIST: [],

  WINDOW_SIZE: null,
  DEVICE: {
    isMobile: false,
    isMobileOnly: false,
    isBrowser: false,
    isIOS: false,
    isAndroid: false,
  },

  SCROLL_STATES: {
    // cabinet
    Filters_block_is_fixed: false,
    reaches_to_bottom: false,
  },

  MODALS: {
    QR: {
      show: false,
      bill: {},
      type: 'bill',
      code: '',
    },
    SHARE: {
      show: false,
      shareInfo: {
        id: null,
        url: '',
        title: '',
        description: '',
        showForm: false,
        socialShown: false,
      },
    },
    ANNULLED_CHECK_REASON: {
      show: false,
    },
    SWITCH_OFF_INDIVIDUAL: {
      show: false,
    },
    MULTIBILL_EDIT: {
      show: false,
      bill: {},
      tariffId: null,
    },
    MARKETPLACE_CATEGORIES: {
      show: false,
      billCode: null,
      categoryCode: null,
      categories: [],
    },
  },
  ///////////////

  // CABINET
  SELECTED_TRANSACTION: {},
  GRAPH: [],
  TRANSACTIONS: {
    page: 1,
    count: 1,
    result: [],
    blink: false,
    loading: false,
    countPerPage: 35,
    searchText: '',
    filterBy: 'all',
    lastDataChunk: [],
    checkEmpty: false,
  },

  // REGISTRATION PROCESS
  REGISTRATION: {
    LOGIN: '',
    PROJECT_LINK: '',
    PROJECT_NAME: '',
    PROMO_CODE: '',
  },

  ///////////////
  CARD_BINDING_TOKEN: '',
  LAST_CARD_BINDING_PAGE: null,

  ///////////////
  WEB_SOCKETS: {
    isConnected: false,
    message: '',
    reconnectError: false,
  },

  SELF_EMPLOYED: {
    loading: false,
    status: null,
    requestId: null,
    properties: null,
    notifications: {
      list: [],
      count: 0,
      loading: false,
    },
  },

  // SUBSCRIPTIONS
  SUBSCRIPTIONS: {
    page: 1,
    count: 1,
    subscribers: [],
    blink: false,
    loading: false,
    countPerPage: 35,
    searchText: '',
    filterBy: 'ALL',
    lastDataChunk: [],
    checkEmpty: false,
  },

  SELECTED_SUBSCRIPTION: {},

  WRITE_OFF_OPTIONS: [],

  MARKETPLACE_CATEGORIES: [],

  PROJECT_LOCALE: {},
};
